import React from 'react';
import { getRandomInt } from '../../util/rng';
import './style.scss';

const shrimpDrawingBodyPath =
  'M371.5,16h-244c-4.687,0-8.5-3.813-8.5-8.5c0-4.143-3.358-7.5-7.5-7.5S104,3.357,104,7.5c0,12.958,10.542,23.5,23.5,23.5 h244c42.182,0,76.5,34.317,76.5,76.5c0,37.646-27.341,69.005-63.204,75.319C403.573,161.704,415,133.913,415,103.5v-16 c0-12.958-10.542-23.5-23.5-23.5h-216c-52.84,0-97.635,20.386-129.543,58.954C16.321,158.776,0,208.689,0,263.5 C0,373.505,89.495,463,199.5,463h96c2.599,0,5.013-1.346,6.38-3.557c1.367-2.212,1.491-4.973,0.328-7.298l-14.494-28.987 l14.749-36.873c1.122-2.804,0.452-6.006-1.698-8.126c-2.151-2.121-5.363-2.744-8.15-1.582l-94.57,39.404 C145.503,415.2,103,372.223,103,319.5c0-52.052,41.429-94.605,93.044-96.431l33.986,40.783c1.271,1.524,1.97,3.457,1.97,5.441 V311.5c0,4.143,3.358,7.5,7.5,7.5s7.5-3.357,7.5-7.5v-42.207c0-5.487-1.935-10.83-5.447-15.045L215.513,223h20.474l34.043,40.852 c1.271,1.524,1.97,3.457,1.97,5.441V311.5c0,4.143,3.358,7.5,7.5,7.5s7.5-3.357,7.5-7.5v-42.207c0-5.487-1.935-10.83-5.447-15.045 L255.513,223h20.474l34.043,40.852c1.271,1.524,1.97,3.457,1.97,5.441V311.5c0,4.143,3.358,7.5,7.5,7.5s7.5-3.357,7.5-7.5v-42.207 c0-5.487-1.935-10.83-5.447-15.045L295.513,223c26.905-0.003,51.759-8.947,71.754-24.011c0.078,0.002,0.155,0.012,0.233,0.012h4 c50.453,0,91.5-41.047,91.5-91.5S421.953,16,371.5,16z M400,87.5v16c0,57.621-46.878,104.5-104.5,104.5h-96 c-0.01,0-0.021,0-0.031,0c-0.007,0-0.015,0-0.022,0c-5.587,0.003-11.078,0.422-16.447,1.222V79h208.5 C396.187,79,400,82.813,400,87.5z M168,79.163v133.375c-12.171,3.59-23.481,9.203-33.541,16.453l-78.303-94.788 c0.452-0.562,0.899-1.131,1.358-1.686C84.964,99.337,123.047,80.993,168,79.163z M97.682,364.918l-37.231,19.711 c-27.797-31.867-44.835-73.342-45.421-118.713l76.55,25.516C89.245,300.403,88,309.809,88,319.5 C88,335.667,91.466,351.038,97.682,364.918z M272.792,426.854L283.365,448H207v-19.5l74.907-31.211l-9.37,23.426 C271.741,422.704,271.834,424.938,272.792,426.854z M192,430.751v17.099c-46.859-1.885-89.267-21.339-120.824-51.927l33.545-17.759 C123.167,407.854,155.161,428.291,192,430.751z M96.339,277.207l-80.991-26.997c2.027-39.193,13.03-75.024,31.701-103.48 l75.852,91.821C111.515,249.333,102.397,262.485,96.339,277.207z';

const shrimpDrawingEyePath =
  'M303.5,143c12.958,0,23.5-10.542,23.5-23.5S316.458,96,303.5,96S280,106.542,280,119.5S290.542,143,303.5,143z M303.5,111 c4.687,0,8.5,3.813,8.5,8.5s-3.813,8.5-8.5,8.5s-8.5-3.813-8.5-8.5S298.813,111,303.5,111z';

const ShrimpDrawing = ({ text, size, color }) => {
  const isValue69 = () => !!(getRandomInt(40, 80) === 69);
  const willSwimAround = () => getRandomInt(1, 10) === 5;
  const shrimpClass = () => {
    if (willSwimAround()) {
      return 'swimmer';
    }
    if (isValue69() && !willSwimAround()) {
      return 'not-dancing';
    }
    return '';
  };

  return (
    <div className={`shrimp-drawing ${shrimpClass()} shrimp-drawing--tracer`}>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        className="shrimp-drawing__vector"
        viewBox="0 0 500 500"
        fill={color || '#666'}
        width={size || 250}
        height={size || 250}
      >
        <text x="40" y="69" className="shrimp-drawing__name">
          {text}
        </text>
        <path className="shrimp-drawing__body" d={shrimpDrawingBodyPath} />
        <path className="shrimp-drawing__eye" d={shrimpDrawingEyePath} />
      </svg>
    </div>
  );
};

export default ShrimpDrawing;
